import {
  getSingerLabel,
  isSingerCompany
} from '@setvi/shared/utils/singer-labels';
import { useAppContext } from 'Providers/AppProvider/AppContext';

export const useSingerLabel = () => {
  const { companyData } = useAppContext();
  const companyId = companyData?.ID;

  return {
    isSinger: isSingerCompany(companyId),
    getLabel: (label: string) => getSingerLabel(label, companyId)
  };
};
